import * as _ from 'lodash';
import { requestWithToken } from './request';

//objectをパラメータに変換
const getURLParams = data => {
  if (!data) {
    return null;
  }
  const url = Object.keys(data)
    .map(val => {
      return `${encodeURIComponent(val)}=${encodeURIComponent(data[val])}`;
    })
    .join('&');
  return url;
};

//リクエスト
const _requestCache = () => {
  let list = {};
  let callbacks = [];

  //リスナー登録
  const listener = (key, callback) => {
    callbacks.push({ key, callback });
  };

  //レスポンスを配信
  const publish = (key, resp) => {
    list[key] = resp;
    _.each(callbacks, item => {
      if (item.key === key && item.callback) {
        item.callback(resp);
      }
    });
  };

  //リクエスト
  const request = (url, params) => {
    return new Promise(resolved => {
      requestWithToken({
        method: 'GET',
        url,
        params,
      }).then(resp => {
        resolved(resp);
      });
    });
  };

  const clear = () => {
    list = {};
  };

  //url+パラメータでキーを返す
  const getKey = (_url, _params) => {
    const url_param = getURLParams(_params);
    return url_param ? _url.concat(`?${url_param}`) : _url;
  };

  //キャッシュを取得
  const get = (url, params) => {
    const key = getKey(url, params);
    //リクエスト済み判定
    const isCacheRequest = _.has(list, key);
    //キャッシュ済み判定
    const isCache = isCacheRequest ? list[key] : null;

    return new Promise(async resolved => {
      if (isCacheRequest && isCache) {
        //キャッシュ登録されてる&&キャッシュが存在する
        resolved(list[key]);
      } else if (isCacheRequest && !isCache) {
        //キャッシュ登録されてる&&キャッシュが存在しない(取得中)
        //取得完了を待つ
        listener(key, response => {
          resolved(response);
        });
      } else {
        //キャッシュ登録されてないて&&キャッシュが存在しない
        //キャッシュ登録
        list[key] = null;
        const response = await request(url, params);
        if (response.result) {
          publish(key, response);
        }
        resolved(response);
      }
    });
  };

  return {
    get,
    clear,
  };
};

export const requestCache = _requestCache();



// WEBPACK FOOTER //
// ./src/utilities/requestCache.js